<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
    <mat-dialog-content>
        <div class="row">
            <div class="col-12 col-sm-4 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Clave Interna</mat-label>
                    <input matInput formControlName="claveInterna" placeholder="Clave Interna"
                        (blur)="form.controls['claveInterna'].markAsTouched()" uppercase alphanumericOnly
                        maxlength="10">
                    <mat-error *ngIf="isValidField('claveInterna')">
                        {{ getFieldError('claveInterna') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4 col-md-4">

            </div>
            <div class="col-12 col-sm-4 col-md-4">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Equipo</mat-label>
                    <input type="text" matInput [formControl]="codigoEquipoControl" [matAutocomplete]="autoEquipo"
                        placeholder="Escribe para buscar..." (focus)="abrirAutocompleteCodigoEquipo()"
                        (blur)="codigoEquipoControl.markAsTouched()" uppercase />
                    <mat-autocomplete #autoEquipo="matAutocomplete" (optionSelected)="seleccionarCodigoEquipo($event)">
                        <mat-option *ngFor="let codigoEquipo of filteredCodigoEquipos$ | async" [value]="codigoEquipo">
                            {{ codigoEquipo.claveEquipo }} - {{ codigoEquipo.nombreEquipo }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="codigoEquipoControl.invalid && codigoEquipoControl.touched">
                        Este campo es obligatorio
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Modelo</mat-label>
                    <input matInput formControlName="modelo" placeholder="Modelo"
                        (blur)="form.controls['modelo'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
                    <mat-error *ngIf="isValidField('modelo')">
                        {{ getFieldError('modelo') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Serie</mat-label>
                    <input matInput formControlName="serie" placeholder="Serie"
                        (blur)="form.controls['serie'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
                    <mat-error *ngIf="isValidField('serie')">
                        {{ getFieldError('serie') }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-4 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Departamento</mat-label>
                    <input type="text" matInput [formControl]="departamentoControl" [matAutocomplete]="autoDepartamento"
                        placeholder="Escribe para buscar..." (focus)="abrirAutocompleteDepartamento()"
                        (blur)="departamentoControl.markAsTouched()" uppercase />
                    <mat-autocomplete #autoDepartamento="matAutocomplete" (optionSelected)="seleccionarDepartamento($event)">
                        <mat-option *ngFor="let departamento of filteredDepartamento$ | async" [value]="departamento">
                            {{ departamento.nombreArea }} 
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="departamentoControl.invalid && departamentoControl.touched">
                        Este campo es obligatorio
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Responsable</mat-label>
                    <input type="text" matInput [formControl]="colaboradorControl" [matAutocomplete]="autoColaborador"
                        placeholder="Escribe para buscar..." (focus)="abrirAutocomplete()"
                        (blur)="colaboradorControl.markAsTouched()" uppercase />
                    <mat-autocomplete #autoColaborador="matAutocomplete" (optionSelected)="seleccionarColaborador($event)">
                        <mat-option *ngFor="let colaborador of filteredColaboradores$ | async" [value]="colaborador">
                            {{ colaborador.idColaborador }} - {{ colaborador.nombre }} {{ colaborador.apellidoPaterno }}
                            {{ colaborador.apellidoMaterno }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="colaboradorControl.invalid && colaboradorControl.touched">
                        Este campo es obligatorio
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Localización</mat-label>
                    <input matInput formControlName="localizacion" placeholder="Localización"
                        (blur)="form.controls['localizacion'].markAsTouched()" uppercase alphanumericOnly
                        maxlength="70">
                    <mat-error *ngIf="isValidField('localizacion')">
                        {{ getFieldError('localizacion') }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Marca</mat-label>
                    <input type="text" matInput [formControl]="marcaControl" [matAutocomplete]="autoMarca"
                        placeholder="Escribe para buscar..." (focus)="abrirAutocompleteMarca()"
                        (blur)="marcaControl.markAsTouched()" uppercase />
                    <mat-autocomplete #autoMarca="matAutocomplete" (optionSelected)="seleccionarMarca($event)">
                        <mat-option *ngFor="let marca of filteredMarca$ | async" [value]="marca">
                            {{ marca.marca }} 
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="marcaControl.invalid && marcaControl.touched">
                        Este campo es obligatorio
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-3 col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>¿Equipo o Patrón?</mat-label>
                    <input matInput formControlName="ep" placeholder="¿Equipo o Patrón?"
                        (blur)="form.controls['ep'].markAsTouched()" uppercase alphanumericOnly maxlength="10">
                    <mat-error *ngIf="isValidField('ep')">
                        {{ getFieldError('ep') }}
                    </mat-error>
                </mat-form-field>
            </div>  
            <div class="col-12 col-sm-1 col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Sig. Calibración</mat-label>
                    <input matInput  placeholder="Sig. Calibración"
                     maxlength="10"  formControlName="fechaCalibracion">
  
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-1 col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Semana</mat-label>
                    <input matInput  placeholder="Semana"
                    maxlength="10"  formControlName="numeroSemana" >

                </mat-form-field>
            </div>          
            <div class="col-12 col-sm-3 col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Calibración</mat-label>
                    <input matInput formControlName="tipCalib" placeholder="Calibración"
                        (blur)="form.controls['tipCalib'].markAsTouched()" uppercase alphanumericOnly maxlength="10">
                    <mat-error *ngIf="isValidField('tipCalib')">
                        {{ getFieldError('tipCalib') }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Estatus</mat-label>
                    <mat-select formControlName="activo" (blur)="form.controls['activo'].markAsTouched()" required>
                        <mat-option  [value]="true">ACTIVO</mat-option>
                        <mat-option  [value]="false">FUERA DE SERVICIO</mat-option>
                    </mat-select>
                    <mat-error *ngIf="isValidField('activo')">
                        {{ getFieldError('activo') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Frec. (Sem.)</mat-label>
                    <input type="number" matInput formControlName="calibFrecuencia" placeholder="Frec. (Sem.)"
                        (blur)="form.controls['calibFrecuencia'].markAsTouched()">
                    <mat-error *ngIf="isValidField('calibFrecuencia')">
                        {{ getFieldError('calibFrecuencia') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Empieza a partir de</mat-label>
                    <input type="date" matInput formControlName="calibApartir" placeholder="Frec. (Sem.)"
                        (blur)="form.controls['calibApartir'].markAsTouched()">
                    <mat-error *ngIf="isValidField('calibApartir')">
                        {{ getFieldError('calibApartir') }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Notas </mat-label>
                    <textarea matInput formControlName="condAlmacenamiento" placeholder="Notas"
                        (blur)="form.controls['condAlmacenamiento'].markAsTouched()" uppercase
                        maxlength="250"></textarea>
                    <mat-error *ngIf="isValidField('condAlmacenamiento')">
                        {{ getFieldError('condAlmacenamiento') }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
            <i class="fa fa-save"></i> Guardar
        </button>
        <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
            <i class="fa fa-remove fa-solid"></i> Cancelar
        </button>
    </mat-dialog-actions>
</form>